import { render, staticRenderFns } from "./BaseAttachmentItem.vue?vue&type=template&id=1b72a37a&scoped=true"
import script from "./BaseAttachmentItem.vue?vue&type=script&lang=js"
export * from "./BaseAttachmentItem.vue?vue&type=script&lang=js"
import style0 from "./BaseAttachmentItem.vue?vue&type=style&index=0&id=1b72a37a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b72a37a",
  null
  
)

export default component.exports